import Vue from 'vue';

const mutations = {
  SET_CLASS_DETAIL: (state, detail) => {
    state.detail = detail;
  },

  CLEAR_CLASS_DETAIL(state) {
    state.detail = {};
  },

  SET_CLASS_INFO(state, classInfo) {
    Vue.set(state.detail, 'class_info', classInfo);
  },

  SET_CLASS_FEEDBACK(state, feedback) {
    Vue.set(state.detail, 'teacher_feedback', feedback);
  },

  REMOVE_SHARED_LESSON: state => {
    Vue.set(state.detail, 'teacher_feedback', {
      ...state.detail.teacher_feedback,
      assigned_lesson: {},
      assigned_lesson_id: null,
      assignments: [],
    });
  },

  SET_CLASS_WARNINGS: (state, warnings) => {
    state.classWarnings = warnings;
  },

  CLEAR_CLASS_WARNINGS: state => {
    state.classWarnings = [];
  },

  SET_REFRESH_DATE: (state, timestamp) => {
    state.lastRefreshDate = timestamp;
  },
};

export default mutations;
